import { qrCodeService, reportService, recentReportFilters } from './api';
import { companyPages } from './companyPages';
import { userApi } from './userApi';

export const routeModules = {
  '/qrcodes': () => import('../pages/QRCodeList'),
  '/reports': () => import('../pages/Reports'),
  '/pages': () => import('../pages/CompanyPages'),
  '/users': () => import('../pages/UserManagement')
};
// Start only on navigation intent. Browsing the dashboard does not fetch every section.
export function prefetchRoute(path) {
  if (navigator.connection?.saveData || document.visibilityState === 'hidden') return;
  routeModules[path]?.().catch(() => {});
  const reads = {
    '/dashboard': () => [qrCodeService.list(), reportService.get(), reportService.get(recentReportFilters())],
    '/qrcodes': () => [qrCodeService.list()],
    '/reports': () => [reportService.get(recentReportFilters()), qrCodeService.inventory()],
    '/pages': () => [companyPages.list()],
    '/users': () => [userApi.listUsers()]
  };
  reads[path]?.().forEach(promise => promise.catch(() => {}));
}